<script setup lang="ts">
/* eslint-env vue/setup-compiler-macros */
defineProps<{
    creditorName: string;
}>();

defineEmits<{
    exit: [];
}>();
</script>

<template>
    <aside
        class="creditor-access-banner"
        aria-label="Creditor portal access"
    >
        <p class="creditor-access-banner__message">
            You are currently logged in to
            <strong>{{ creditorName }}’s portal</strong>
        </p>
        <button
            type="button"
            class="creditor-access-banner__exit"
            aria-label="Exit creditor portal access"
            @click="$emit('exit')"
        >
            Exit Access
        </button>
    </aside>
</template>

<style lang="scss" scoped>
.creditor-access-banner {
    position: sticky;
    top: 0;
    z-index: 1000;
    display: flex;
    flex: 0 0 59px;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 59px;
    padding: 15px 40px;
    background: $main-orange;
    color: $white-color;

    &__message {
        margin: 0;
        font-family: $font-family-archivo;
        font-size: 15px;
        font-style: normal;
        font-weight: 300;
        line-height: 20px;

        strong {
            font-weight: 600;
        }
    }

    &__exit {
        display: inline-flex;
        flex: 0 0 112px;
        align-items: center;
        justify-content: center;
        width: 112px;
        height: 29px;
        padding: 8px 13px 7px;
        border: 1px solid $white-color;
        border-radius: 6px;
        background: transparent;
        color: $white-color;
        font-family: $font-family-archivo;
        font-size: 13px;
        font-weight: 600;
        line-height: 14px;
        letter-spacing: 0;
        text-align: right;
        text-transform: uppercase;
        white-space: nowrap;
        cursor: pointer;

        &:hover,
        &:focus-visible {
            background: rgba($white-color, 0.12);
        }

        &:focus-visible {
            outline: 2px solid $white-color;
            outline-offset: 2px;
        }
    }
}

@media (max-width: 640px) {
    .creditor-access-banner {
        padding: 0 20px;

        &__message {
            padding-right: 16px;
            font-size: 14px;
        }

        &__exit {
            flex-basis: 112px;
        }
    }
}
</style>
